import { CellProps } from 'react-table'
import { formatDateTime } from '../../../../../../../../_metronic/helpers/crud-helper/helpers'
import { StackedCell } from '../../../../../../../components/Table/TableCells'
import { PlainHeader } from '../../../../../../../components/Table/SortableHeader'
import { TableColumn } from '../../../../../../../components/Table/tableTypes'
import { SituacaoProtocoloBadge } from '../../../../components/SituacaoProtocoloBadge'
import { ModeloVersaoLinha } from '../../../../core/_models'
import { ModeloPlataformaActionsCell } from './ModeloPlataformaActionsCell'

// O endpoint devolve a lista inteira, sem ordenação no servidor: cabeçalhos sem ordenação.
export const modeloPlataformaColumns: ReadonlyArray<TableColumn<ModeloVersaoLinha>> = [
  {
    Header: () => <PlainHeader>Versão / Nome</PlainHeader>,
    id: 'versao',
    Cell: ({ row }: CellProps<ModeloVersaoLinha>) => (
      <StackedCell primary={`Versão ${row.original.versao}`} secondary={row.original.nome} />
    ),
  },
  {
    Header: () => <PlainHeader>Situação</PlainHeader>,
    id: 'situacao',
    cellWidth: '140px',
    Cell: ({ row }: CellProps<ModeloVersaoLinha>) => (
      <SituacaoProtocoloBadge situacao={row.original.situacao} escopo='modelo' />
    ),
  },
  {
    Header: () => <PlainHeader>Hash</PlainHeader>,
    id: 'hash',
    cellWidth: '150px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<ModeloVersaoLinha>) => (
      <StackedCell tabular primary={<code>{row.original.hash.slice(0, 12)}</code>} />
    ),
  },
  {
    Header: () => <PlainHeader>Publicação / Origem</PlainHeader>,
    id: 'publicacao',
    cellWidth: '200px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<ModeloVersaoLinha>) => (
      <StackedCell
        tabular
        primary={row.original.dtPublicacao ? formatDateTime(row.original.dtPublicacao) : undefined}
        secondary={row.original.recursoCargaInicial ? 'Carga inicial' : undefined}
      />
    ),
  },
  {
    Header: () => <PlainHeader>Ações</PlainHeader>,
    id: 'actions',
    cellWidth: '100px',
    align: 'end',
    Cell: ({ row }: CellProps<ModeloVersaoLinha>) => (
      <ModeloPlataformaActionsCell versao={row.original} />
    ),
  },
]
